import { PaymentPeriod } from 'api/fleet/types'
import {
  EQUIPMENT_DETAILS_FORM_VALUES,
  RADIO_BUTTON_LABELS,
} from 'texts/equipmentDetails'

export const initialFormValues = {
  price: '',
  maxAmount: '',
  hirePoints: [],
  priceFor: '1',
  extraId: '',
}

export const RADIO_BUTTONS = [
  { label: RADIO_BUTTON_LABELS.RENT, id: String(PaymentPeriod.Rent) },
  { label: RADIO_BUTTON_LABELS.DAY, id: String(PaymentPeriod.Day) },
]

export const REQUIRED_FIELDS_MIGRATED_USER = {
  [EQUIPMENT_DETAILS_FORM_VALUES.EQUIPMENT_NAME.ID]:
    EQUIPMENT_DETAILS_FORM_VALUES.EQUIPMENT_NAME.REQUIRED_MESSAGE,
  [EQUIPMENT_DETAILS_FORM_VALUES.LOCATION.ID]:
    EQUIPMENT_DETAILS_FORM_VALUES.LOCATION.REQUIRED_MESSAGE,
  [EQUIPMENT_DETAILS_FORM_VALUES.PRICE.ID]:
    EQUIPMENT_DETAILS_FORM_VALUES.PRICE.REQUIRED_MESSAGE,
  [EQUIPMENT_DETAILS_FORM_VALUES.SUM_FOR.ID]:
    EQUIPMENT_DETAILS_FORM_VALUES.SUM_FOR.REQUIRED_MESSAGE,
}
